/**
 * Les types d'environnement du portail colloc
 */
export const HuitabProfiles = {
  DEV: 'dev',
  PROD: 'prod',
};
